/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Section_MarketingInputs */

const cs_nav_section_marketing = /** @type {(inputs: Nav_Section_MarketingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketing`)
};

const en_nav_section_marketing = /** @type {(inputs: Nav_Section_MarketingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketing`)
};

/**
* | output |
* | --- |
* | "Marketing" |
*
* @param {Nav_Section_MarketingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_section_marketing = /** @type {((inputs?: Nav_Section_MarketingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Section_MarketingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_section_marketing(inputs)
	return cs_nav_section_marketing(inputs)
});